import React from "react";
import { Phone, MessageCircle } from "lucide-react";
import { COMPANY, buildWhatsAppUrl } from "@/lib/constants";

const FloatingActions = () => {
  return (
    <>
      <a
        href={buildWhatsAppUrl("Hi Cabsab.com, I'd like to book a cab.")}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="floating-whatsapp-btn"
        aria-label="Chat on WhatsApp"
        className="fixed bottom-5 right-5 z-40 h-14 w-14 rounded-full bg-emerald-500 hover:bg-emerald-600 text-white flex items-center justify-center shadow-[0_12px_30px_rgba(16,185,129,0.35)] pulse-ring transition-transform hover:scale-110"
      >
        <MessageCircle className="h-6 w-6" />
      </a>
      <a
        href={`tel:${COMPANY.phoneTel}`}
        data-testid="floating-call-btn"
        aria-label="Call Now"
        className="fixed bottom-5 left-5 z-40 md:hidden h-14 w-14 rounded-full bg-[#19A8E8] hover:bg-[#0E8AC4] text-white flex items-center justify-center shadow-[0_12px_30px_rgba(25,168,232,0.40)] pulse-ring transition-transform hover:scale-110"
      >
        <Phone className="h-6 w-6" />
      </a>
    </>
  );
};

export default FloatingActions;
